export default __webpack_public_path__ + "static/media/robert-johnson.1a98d05f.jpg";